module.exports = __webpack_public_path__ + "img/modal-el-detail.bd8d7edb.svg";